import type { LocationContent } from "./types";
import { arizona_seo } from "./arizona-seo";
import { arkansas_seo } from "./arkansas-seo";
import { connecticut_seo } from "./connecticut-seo";
import { delaware_seo } from "./delaware-seo";
import { florida_seo } from "./florida-seo";
import { georgia_seo } from "./georgia-seo";
import { illinois_seo } from "./illinois-seo";
import { indiana_seo } from "./indiana-seo";
import { iowa_seo } from "./iowa-seo";
import { kansas_seo } from "./kansas-seo";
import { louisiana_seo } from "./louisiana-seo";
import { maryland_seo } from "./maryland-seo";
import { michigan_seo } from "./michigan-seo";
import { minnesota_seo } from "./minnesota-seo";
import { montana_seo } from "./montana-seo";
import { nevada_seo } from "./nevada-seo";
import { new_hampshire_seo } from "./new-hampshire-seo";
import { new_mexico_seo } from "./new-mexico-seo";
import { new_york_seo } from "./new-york-seo";
import { north_carolina_seo } from "./north-carolina-seo";
import { north_dakota_seo } from "./north-dakota-seo";
import { ohio_seo } from "./ohio-seo";
import { pennsylvania_seo } from "./pennsylvania-seo";
import { south_carolina_seo } from "./south-carolina-seo";
import { tennessee_seo } from "./tennessee-seo";
import { texas_seo } from "./texas-seo";
import { vermont_seo } from "./vermont-seo";
import { virginia_seo } from "./virginia-seo";
import { washington_dc_seo } from "./washington-dc-seo";
import { west_virginia_seo } from "./west-virginia-seo";
import { wisconsin_seo } from "./wisconsin-seo";
import { wyoming_seo } from "./wyoming-seo";
import { atlanta_seo } from "./atlanta-seo";
import { austin_seo } from "./austin-seo";
import { boston_seo } from "./boston-seo";
import { chicago_seo } from "./chicago-seo";
import { cleveland_seo } from "./cleveland-seo";
import { dallas_seo } from "./dallas-seo";
import { denver_seo } from "./denver-seo";
import { fresno_seo } from "./fresno-seo";
import { houston_seo } from "./houston-seo";
import { jacksonville_seo } from "./jacksonville-seo";
import { long_island_seo } from "./long-island-seo";
import { los_angeles_seo } from "./los-angeles-seo";
import { miami_seo } from "./miami-seo";
import { orlando_seo } from "./orlando-seo";
import { peoria_seo } from "./peoria-seo";
import { philadelphia_seo } from "./philadelphia-seo";
import { phoenix_seo } from "./phoenix-seo";
import { portland_seo } from "./portland-seo";
import { sacramento_seo } from "./sacramento-seo";
import { san_antonio_seo } from "./san-antonio-seo";
import { san_bernardino_seo } from "./san-bernardino-seo";
import { san_diego_seo } from "./san-diego-seo";
import { san_francisco_seo } from "./san-francisco-seo";
import { santa_ana_seo } from "./santa-ana-seo";
import { seattle_seo } from "./seattle-seo";
import { stockton_seo } from "./stockton-seo";
import { tampa_seo } from "./tampa-seo";
import { tucson_seo } from "./tucson-seo";
import { tulsa_seo } from "./tulsa-seo";
import { ventura_county_seo } from "./ventura-county-seo";

import { las_vegas_seo } from "./las-vegas-seo";
import { scottsdale_seo } from "./scottsdale-seo";
import { minneapolis_seo } from "./minneapolis-seo";
import { kansas_city_seo } from "./kansas-city-seo";
import { baltimore_seo } from "./baltimore-seo";
import { charlotte_seo } from "./charlotte-seo";
import { nashville_seo } from "./nashville-seo";

export const locationContent: Record<string, LocationContent> = {
  "las-vegas-seo": las_vegas_seo,
  "scottsdale-seo": scottsdale_seo,
  "minneapolis-seo": minneapolis_seo,
  "kansas-city-seo": kansas_city_seo,
  "baltimore-seo": baltimore_seo,
  "charlotte-seo": charlotte_seo,
  "nashville-seo": nashville_seo,

  "arizona-seo": arizona_seo,
  "arkansas-seo": arkansas_seo,
  "connecticut-seo": connecticut_seo,
  "delaware-seo": delaware_seo,
  "florida-seo": florida_seo,
  "georgia-seo": georgia_seo,
  "illinois-seo": illinois_seo,
  "indiana-seo": indiana_seo,
  "iowa-seo": iowa_seo,
  "kansas-seo": kansas_seo,
  "louisiana-seo": louisiana_seo,
  "maryland-seo": maryland_seo,
  "michigan-seo": michigan_seo,
  "minnesota-seo": minnesota_seo,
  "montana-seo": montana_seo,
  "nevada-seo": nevada_seo,
  "new-hampshire-seo": new_hampshire_seo,
  "new-mexico-seo": new_mexico_seo,
  "new-york-seo": new_york_seo,
  "north-carolina-seo": north_carolina_seo,
  "north-dakota-seo": north_dakota_seo,
  "ohio-seo": ohio_seo,
  "pennsylvania-seo": pennsylvania_seo,
  "south-carolina-seo": south_carolina_seo,
  "tennessee-seo": tennessee_seo,
  "texas-seo": texas_seo,
  "vermont-seo": vermont_seo,
  "virginia-seo": virginia_seo,
  "washington-dc-seo": washington_dc_seo,
  "west-virginia-seo": west_virginia_seo,
  "wisconsin-seo": wisconsin_seo,
  "wyoming-seo": wyoming_seo,
  "atlanta-seo": atlanta_seo,
  "austin-seo": austin_seo,
  "boston-seo": boston_seo,
  "chicago-seo": chicago_seo,
  "cleveland-seo": cleveland_seo,
  "dallas-seo": dallas_seo,
  "denver-seo": denver_seo,
  "fresno-seo": fresno_seo,
  "houston-seo": houston_seo,
  "jacksonville-seo": jacksonville_seo,
  "long-island-seo": long_island_seo,
  "los-angeles-seo": los_angeles_seo,
  "miami-seo": miami_seo,
  "orlando-seo": orlando_seo,
  "peoria-seo": peoria_seo,
  "philadelphia-seo": philadelphia_seo,
  "phoenix-seo": phoenix_seo,
  "portland-seo": portland_seo,
  "sacramento-seo": sacramento_seo,
  "san-antonio-seo": san_antonio_seo,
  "san-bernardino-seo": san_bernardino_seo,
  "san-diego-seo": san_diego_seo,
  "san-francisco-seo": san_francisco_seo,
  "santa-ana-seo": santa_ana_seo,
  "seattle-seo": seattle_seo,
  "stockton-seo": stockton_seo,
  "tampa-seo": tampa_seo,
  "tucson-seo": tucson_seo,
  "tulsa-seo": tulsa_seo,
  "ventura-county-seo": ventura_county_seo,
};
